const KICKOUT = 'kickout'

export default {
  listen (user) {
    const es = new EventSource(`/listen/channels/chief,chief:${user.username}`, { withCredentials: true })
    es.addEventListener(KICKOUT, (e) => { document.location.reload() })
  }
}
